import Api from '@/services/Api'

export default {
  strict: true,
  state: {
    applicationactivepage: null,
    selectedapplicationid: 0,
    selectedapplicationidsubmitted: 0,
    selectedapplicationidpending: 0,
    selectedapplicationidverified: 0,
    selectedapplicationidapproved: 0,
    selectedapplicationidrejected: 0,
    selectedapplicationidcancelled: 0,
    applicationslistsubmitted: [],
    applicationslistpending: [],
    applicationslistverified: [],
    applicationslistapproved: [],
    applicationslistrejected: [],
    applicationslistcancelled: [],
    croplist: [],
    countrylist: [],
    cropRules: [
      v => !!v || 'Crop is required'
    ],
    companyRules: [
      v => !!v || 'Company is required',
      v => (v && v.length > 1) || 'Company must have more than 1 character'
    ],
    commentRules: [
    ],
    newcommentRules: {
      required: true,
      max: 10
    },
    varietyRules: [
      v => !!v || 'Variety is required',
      v => (v && v.length > 1) || 'Variety must have more than 1 character'
    ],
    countryRules: [
      v => !!v || 'Country is required'
    ]
  },
  actions: {
    innitialiseData ({dispatch}) {
      dispatch('fetchApplicationslistsubmitted')
      dispatch('fetchApplicationslistpending')
      dispatch('fetchApplicationslistverified')
      dispatch('fetchApplicationslistapproved')
      dispatch('fetchApplicationslistrejected')
      dispatch('fetchApplicationslistcancelled')
      dispatch('fetchCrops')
      dispatch('fetchCountries')
    },
    uploadVerificationvalue ({commit, rootState, getters, dispatch}, values) {
      return new Promise((resolve, reject) => {
        Api().post('review/update', values, getters.getheader).then(response => {
          dispatch('fetchVerificationdetails')
          resolve(response)
        }).catch(error => {
          if (error.response.status === 401) {
            dispatch('logout')
          }
          return Promise.reject(error.response)
        })
      })
    },
    fetchVerificationdetails ({commit, state, getters, dispatch}) {
      return new Promise((resolve, reject) => {
        Api().get('review/view?application_id=' + getters.getSelectedapplicationid, getters.getheader).then(response => {
          commit('setVerificationdetails', response.data.replydata)
          if (response.data.replydata.length === 1) {
            commit('setApplicationverified', response.data.replydata[0].applicationstatus)
          } else {
            commit('setApplicationverified', 0)
          }
        }).catch(error => {
          if (error.response.status === 401) {
            dispatch('logout')
          }
          return Promise.reject(error.response)
        })
      })
    },
    fetchApplicationslistsubmitted ({commit, state, getters, dispatch}) {
      return new Promise((resolve, reject) => {
        Api().get('applications/viewsubmitted', getters.getheader).then(response => {
          commit('setApplicationslistsubmitted', response.data.applicationslist)
          commit('setMenuitems', {id: 0, numbervalue: Object.keys(response.data.applicationslist).length})
          resolve(response)
        }).catch(error => {
          if (error.response.status === 401) {
            dispatch('logout')
          }
          return Promise.reject(error.response)
        })
      })
    },
    fetchApplicationslistpending ({commit, state, getters, dispatch}) {
      return new Promise((resolve, reject) => {
        Api().get('applications/viewpending', getters.getheader).then(response => {
          commit('setApplicationslistpending', response.data.applicationslist)
          commit('setMenuitems', {id: 1, numbervalue: Object.keys(response.data.applicationslist).length})
          resolve(response)
        }).catch(error => {
          if (error.response.status === 401) {
            dispatch('logout')
          }
          return Promise.reject(error.response)
        })
      })
    },
    fetchApplicationslistapproved ({commit, state, getters, dispatch}) {
      return new Promise((resolve, reject) => {
        Api().get('applications/viewapproved', getters.getheader).then(response => {
          commit('setApplicationslistapproved', response.data.applicationslist)
          commit('setMenuitems', {id: 2, numbervalue: Object.keys(response.data.applicationslist).length})
          resolve(response)
        }).catch(error => {
          if (error.response.status === 401) {
            dispatch('logout')
          }
          return Promise.reject(error.response)
        })
      })
    },
    fetchApplicationslistrejected ({commit, state, getters, dispatch}) {
      return new Promise((resolve, reject) => {
        Api().get('applications/viewrejected', getters.getheader).then(response => {
          commit('setApplicationslistrejected', response.data.applicationslist)
          commit('setMenuitems', {id: 3, numbervalue: Object.keys(response.data.applicationslist).length})
          resolve(response)
        }).catch(error => {
          if (error.response.status === 401) {
            dispatch('logout')
          }
          return Promise.reject(error.response)
        })
      })
    },
    fetchApplicationslistverified ({commit, state, getters, dispatch}) {
      return new Promise((resolve, reject) => {
        Api().get('applications/viewverified', getters.getheader).then(response => {
          commit('setApplicationslistverified', response.data.applicationslist)
          commit('setMenuitems', {id: 2, numbervalue: Object.keys(response.data.applicationslist).length})
          resolve(response)
        }).catch(error => {
          if (error.response.status === 401) {
            dispatch('logout')
          }
          return Promise.reject(error.response)
        })
      })
    },
    fetchApplicationslistcancelled ({commit, state, getters, dispatch}) {
      return new Promise((resolve, reject) => {
        Api().get('applications/viewcancelled', getters.getheader).then(response => {
          commit('setApplicationslistcancelled', response.data.applicationslist)
          commit('setMenuitems', {id: 4, numbervalue: Object.keys(response.data.applicationslist).length})
          resolve(response)
        }).catch(error => {
          if (error.response.status === 401) {
            dispatch('logout')
          }
          return Promise.reject(error.response)
        })
      })
    },
    updateApplication ({commit, state, getters, dispatch}, formdata) {
      console.log('update application api')
      return new Promise((resolve, reject) => {
        Api().post('application/update', formdata, getters.getheader).then(response => {
          dispatch('fetchApplicationslistsubmitted')
          dispatch('fetchApplicationslistpending')
          dispatch('fetchApplicationslistverified')
          dispatch('fetchApplicationslistapproved')
          dispatch('fetchApplicationslistrejected')
          dispatch('fetchApplicationslistcancelled')
          resolve(response)
        }).catch(error => {
          console.log('error update')
          if (error.response.status === 401) {
            dispatch('logout')
          }
          return Promise.reject(error.response)
        })
      })
    },
    createApplication ({commit, state, getters, dispatch}, formdata) {
      console.log('form data for creating new application:')
      console.log(formdata.comment)
      console.log(formdata.crop_id)
      return new Promise((resolve, reject) => {
        Api().post('application/create', formdata, getters.getheader).then(response => {
          // dispatch('fetchApplicationslist')
          dispatch('fetchApplicationslistsubmitted')
          resolve(response)
        }).catch(error => {
          if (error.response.status === 401) {
            dispatch('logout')
          }
          return Promise.reject(error.response)
        })
      })
    },
    fetchCrops ({commit, rootState, getters, dispatch}) {
      return new Promise((resolve, reject) => {
        Api().get('crops/view', getters.getheader).then(response => {
          commit('setCrops', response.data.cropslist)
          resolve(response)
        }).catch(error => {
          if (error.response.status === 401) {
            dispatch('logout')
          }
          return Promise.reject(error.response)
        })
      })
    },
    fetchCountries ({commit, rootState, getters, dispatch}) {
      return new Promise((resolve, reject) => {
        Api().get('country/view', getters.getheader).then(response => {
          commit('setCountries', response.data.countrylist)
          resolve(response)
        }).catch(error => {
          if (error.response.status === 401) {
            dispatch('logout')
          }
          return Promise.reject(error.response)
        })
      })
    }
  },
  mutations: {
    setApplicationactivepage (state, applicationactivepage) {
      state.applicationactivepage = applicationactivepage
    },
    setSelectedapplicationid (state, selectedapplicationid) {
      state.selectedapplicationid = selectedapplicationid
    },
    setSelectedapplicationidsubmitted (state, selectedapplicationidsubmitted) {
      state.selectedapplicationidsubmitted = selectedapplicationidsubmitted
    },
    setSelectedapplicationidpending (state, selectedapplicationidpending) {
      state.selectedapplicationidpending = selectedapplicationidpending
    },
    setSelectedapplicationidverified (state, selectedapplicationidverified) {
      state.selectedapplicationidverified = selectedapplicationidverified
    },
    setSelectedapplicationidapproved (state, selectedapplicationidapproved) {
      state.selectedapplicationidapproved = selectedapplicationidapproved
    },
    setSelectedapplicationidrejected (state, selectedapplicationidrejected) {
      state.selectedapplicationidrejected = selectedapplicationidrejected
    },
    setSelectedapplicationidcancelled (state, selectedapplicationidcancelled) {
      state.selectedapplicationidcancelled = selectedapplicationidcancelled
    },
    setApplicationslistsubmitted (state, applicationslist) {
      state.applicationslistsubmitted = applicationslist
    },
    setApplicationslistpending (state, applicationslist) {
      state.applicationslistpending = applicationslist
    },
    setApplicationslistverified (state, applicationslist) {
      state.applicationslistverified = applicationslist
    },
    setApplicationslistapproved (state, applicationslist) {
      state.applicationslistapproved = applicationslist
    },
    setApplicationslistrejected (state, applicationslist) {
      state.applicationslistrejected = applicationslist
    },
    setApplicationslistcancelled (state, applicationslist) {
      state.applicationslistcancelled = applicationslist
    },
    setCrops (state, croplist) {
      state.croplist = croplist
    },
    setCountries (state, countrylist) {
      state.countrylist = countrylist
    }
  },
  getters: {
    getApplicationactivepage (state, getters) {
      return state.applicationactivepage
    },
    getSelectedapplicationid (state, getters) {
      return state.selectedapplicationid
    },
    getSelectedapplicationidsubmitted (state, getters) {
      return state.selectedapplicationidsubmitted
    },
    getSelectedapplicationidpending (state, getters) {
      return state.selectedapplicationidpending
    },
    getSelectedapplicationidverified (state, getters) {
      return state.selectedapplicationidverified
    },
    getSelectedapplicationidapproved (state, getters) {
      return state.selectedapplicationidapproved
    },
    getSelectedapplicationidrejected (state, getters) {
      return state.selectedapplicationidrejected
    },
    getSelectedapplicationidcancelled (state, getters) {
      return state.selectedapplicationidcancelled
    },
    getCroprules (state, getters) {
      return state.cropRules
    },
    getCompanyrules (state, getters) {
      return state.companyRules
    },
    getCommentrules (state, getters) {
      return state.commentRules
    },
    getNewcommentrules (state, getters) {
      return state.newcommentRules
    },
    getVarietyrules (state, getters) {
      return state.varietyRules
    },
    getCountryrules (state, getters) {
      return state.countryRules
    },
    getApplicationslistsubmitted (state, getters) {
      return state.applicationslistsubmitted
    },
    getApplicationslistpending (state, getters) {
      return state.applicationslistpending
    },
    getApplicationslistverified (state, getters) {
      return state.applicationslistverified
    },
    getApplicationslistapproved (state, getters) {
      return state.applicationslistapproved
    },
    getApplicationslistrejected (state, getters) {
      return state.applicationslistrejected
    },
    getApplicationslistcancelled (state, getters) {
      return state.applicationslistcancelled
    },
    getApplicationslistsubmittedfirstelementid (state, getters) {
      if (Object.keys(getters.getApplicationslistsubmitted).length > 0) {
        if (typeof getters.getSelectedapplicationid === 'undefined') {
          return getters.getApplicationslistsubmitted[Object.keys(getters.getApplicationslistsubmitted)[Object.keys(getters.getApplicationslistsubmitted).length - 1]]
        } else {
          if (typeof getters.getApplicationslistsubmitted[getters.getSelectedapplicationid] === 'undefined') {
            return getters.getApplicationslistsubmitted[Object.keys(getters.getApplicationslistsubmitted)[Object.keys(getters.getApplicationslistsubmitted).length - 1]]
          } else {
            return getters.getSelectedapplicationid
          }
        }
      } else {
        console.log('list is empty set selected application id = 0')
        return 0
      }
    },
    getApplicationslistpendingfirstelementid (state, getters) {
      if (getters.getApplicationslistpending[getters.getSelectedapplicationid] === 'undefined') {
        if (Object.keys(getters.getApplicationslistpending).length > 0) {
          return getters.getApplicationslistpending[Object.keys(getters.getApplicationslistpending)[Object.keys(getters.getApplicationslistpending).length - 1]]
        } else {
          return 0
        }
      } else {
        return getters.getSelectedapplicationid
      }
    },
    getApplicationslistverifiedfirstelementid (state, getters) {
      if (getters.getApplicationslistverified[getters.getSelectedapplicationid] === 'undefined') {
        if (Object.keys(getters.getApplicationslistverified).length > 0) {
          return getters.getApplicationslistverified[Object.keys(getters.getApplicationslistverified)[Object.keys(getters.getApplicationslistverified).length - 1]]
        } else {
          return 0
        }
      } else {
        return getters.getSelectedapplicationid
      }
    },
    getApplicationslistapprovedfirstelementid (state, getters) {
      if (getters.getApplicationslistapproved[getters.getSelectedapplicationid] === 'undefined') {
        if (Object.keys(getters.getApplicationslistapproved).length > 0) {
          return getters.getApplicationslistapproved[Object.keys(getters.getApplicationslistapproved)[Object.keys(getters.getApplicationslistapproved).length - 1]]
        } else {
          return 0
        }
      } else {
        return getters.getSelectedapplicationid
      }
    },
    getApplicationslistrejectedfirstelementid (state, getters) {
      if (getters.getApplicationslistrejected[getters.getSelectedapplicationid] === 'undefined') {
        if (Object.keys(getters.getApplicationslistrejected).length > 0) {
          return getters.getApplicationslistrejected[Object.keys(getters.getApplicationslistrejected)[Object.keys(getters.getApplicationslistrejected).length - 1]]
        } else {
          return 0
        }
      } else {
        return getters.getSelectedapplicationid
      }
    },
    getApplicationslistcancelledfirstelementid (state, getters) {
      if (getters.getApplicationslistcancelled[getters.getSelectedapplicationid] === 'undefined') {
        if (Object.keys(getters.getApplicationslistcancelled).length > 0) {
          return getters.getApplicationslistcancelled[Object.keys(getters.getApplicationslistcancelled)[Object.keys(getters.getApplicationslistcancelled).length - 1]]
        } else {
          return 0
        }
      } else {
        return getters.getSelectedapplicationid
      }
    },
    getCrops (state, getters) {
      return state.croplist
    },
    getCountries (state, getters) {
      return state.countrylist
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/applicationsapi.js